/* チェックボックス */
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
var CheckBox = function (_a) {
    var id = _a.id, value = _a.value, label = _a.label, need = _a.need, sources = _a.sources, name = _a.name, message = _a.message, help_msg = _a.help_msg, disabled = _a.disabled, handleChange = _a.handleChange;
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: React.createElement(React.Fragment, null,
            React.createElement(InputGroup, null, sources.map(function (src, index) {
                return (React.createElement("label", { className: "check-box-label", key: src.key },
                    React.createElement(Form.Check, { disabled: disabled, id: id + "-" + index, type: "checkbox", inline: true, value: src.key, name: name, defaultChecked: value.includes(src.key), onChange: handleChange, className: "check-box" }),
                    src.value));
            })),
            disabled || React.createElement(Messages, { help_msg: help_msg, valid_msg: message })) }));
};
export default CheckBox;
